import moment from 'moment';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import DatePicker from './DatePicker';

function ScheduleHeader({ viewType, setViewType, startDate, onPrevious, onNext, onDateChange, onToday, onAddBooking }) {
  const viewModes = ['Day', 'Week', 'Month'];

  // Calculate date range display based on view type
  const getDateRangeDisplay = () => {
    if (viewType === 'Week') {
      const endDate = moment(startDate).add(6, 'days');
      return `${startDate.format('MMM D, YYYY')} - ${endDate.format('MMM D, YYYY')}`;
    } else if (viewType === 'Day') {
      return startDate.format('dddd, MMM D, YYYY');
    } else if (viewType === 'Month') {
      return startDate.format('MMMM YYYY');
    }
    return startDate.format('MMM D, YYYY');
  };

  return (
    <div className="flex items-center justify-between mb-6">
      {/* Date Navigation */}
      <div className="flex items-center gap-4">
        <button onClick={onPrevious} className="p-2 hover:bg-gray-100 rounded-md cursor-pointer">
          <ChevronLeftIcon className="h-5 w-5 text-gray-600" />
        </button>
        <DatePicker 
          startDate={startDate}
          onDateChange={onDateChange}
          dateDisplay={getDateRangeDisplay()}
        />
        <button onClick={onNext} className="p-2 hover:bg-gray-100 rounded-md cursor-pointer">
          <ChevronRightIcon className="h-5 w-5 text-gray-600" />
        </button>
        <button 
          onClick={onToday}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 cursor-pointer"
        >
          Today
        </button>
      </div>

      {/* View Mode Toggle + Add */}
      <div className="flex items-center gap-3">
        <div className="inline-flex rounded-lg border border-gray-300 bg-white p-1">
          {viewModes.map((mode) => (
            <button
              key={mode}
              onClick={() => setViewType(mode)}
              className={`px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer ${
                viewType === mode
                  ? 'bg-gray-900 text-white'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              {mode}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={onAddBooking}
          disabled={!onAddBooking}
          className={`inline-flex items-center justify-center rounded-md px-4 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
            onAddBooking ? 'bg-indigo-600 hover:bg-indigo-500' : 'bg-gray-400 cursor-not-allowed'
          }`}
        >
          Add
        </button>
      </div>
    </div>
  );
}

export default ScheduleHeader;
